import script from "./RegisteringI18nRegisteringForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisteringI18nRegisteringForm.vue?vue&type=script&setup=true&lang=ts"

import "./RegisteringI18nRegisteringForm.vue?vue&type=style&index=0&id=6afa9904&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6afa9904"]])

export default __exports__